import React, { useEffect, useContext, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import moment from 'moment';
import useFormValidator from 'useFormValidator';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import CmsContext from 'context/CmsContext';
import * as actions from '../../action';
import * as c from '../../constant';
import OwnerDetails from './components/OwnerDetails';
import AdministratorDetails from './components/AdministratorDetails';
import LandReference from './components/LandReference';
import GeneralDescription from './components/GeneralDescription';

function NewDeclarationContainer({
  getMachineryOwnerList,
  createMachineryApplicationTransaction,
  getMachineryApplicationsList,
  history,
  transactionCode,
  createRichTextEditor,
  formData,
  setFormData,
  modalType,
  convertToRaw,
  draftToHtml,
}) {
  const setModal = useContext(ModalContext);
  const cmsContext = useContext(CmsContext);
  const CMS_COMPONENTS = cmsContext.findByType('COMPONENTS');
  const [tab, setTab] = useState(0);

  const RULES = {
    tab0: {
      rules: {
        rptax_machinery_owner_id: 'required',
      },
    },
    tab1: {
      rules: {},
    },
    tab2: {
      rules: {
        tdn: 'required|rptax_tdn',
        land_application_id: 'required',
        property_district_id: 'required',
        property_barangay_id: 'required',
        property_street: 'required',
      },
    },
    tab3: {
      rules: {
        effectivity_of_assessment_reassessment_yr: 'required',
        effectivity_of_assessment_reassessment_qtr: 'required',
        appraised_assessed_by_id: 'required',
        appraised_assessed_at: 'required',
        recommending_by_id: 'required',
        recommending_at: 'required',
        approved_by_id: 'required',
        approved_at: 'required',
        registered: 'required',
        memoranda: 'required'
      },
    },
  };

  const tab0Validator = useFormValidator(
    formData,
    RULES.tab0.rules,
    RULES.tab0.message
  );

  const tab1Validator = useFormValidator(
    formData,
    RULES.tab1.rules,
    RULES.tab1.message
  );

  const tab2Validator = useFormValidator(
    formData,
    RULES.tab2.rules,
    RULES.tab2.message
  );

  const tab3Validator = useFormValidator(
    formData,
    RULES.tab3.rules,
    RULES.tab3.message
  );

  const validateForm = () => {
    if (tab === 0) {
      if (!tab0Validator.response.is_passed) {
        return false;
      }
      return setTab(+tab + 1);
    }
    if (tab === 1) {
      if (!tab1Validator.response.is_passed) {
        return false;
      }
      return setTab(+tab + 1);
    }
    if (tab === 2) {
      if (!tab2Validator.response.is_passed) {
        return false;
      }
      return setTab(+tab + 1);
    }

    if (tab === 3) {
      if (!tab3Validator.response.is_passed) {
        return false;
      }
    }
    return true;
  };

  const handleOnSubmit = (e) => {
    e.preventDefault();

    if (validateForm() !== true) {
      return false;
    }

    const rptax_machinery_co_owner_ids = [];

    (_.get(formData, 'co_owners_ids') || []).forEach((info) => {
      rptax_machinery_co_owner_ids.push(info.co_owners_ids);
    });

    const args = {
      ...formData,
      rptax_building_owner_id: formData.rptax_building_owner_id ?? null,
      rptax_transaction_code_id: transactionCode,
      appraised_assessed_at: `${moment(
        _.get(formData, 'appraised_assessed_at')
      ).format('YYYY-MM-DD HH:mm:00')}`,
      recommending_at: `${moment(_.get(formData, 'recommending_at')).format(
        'YYYY-MM-DD HH:mm:00'
      )}`,
      approved_at: `${moment(_.get(formData, 'approved_at')).format(
        'YYYY-MM-DD HH:mm:00'
      )}`,
      registered: `${moment(_.get(formData, 'registered')).format(
        'YYYY-MM-DD HH:mm:00'
      )}`,
      memoranda: formData.memoranda !== '' ? draftToHtml(
        convertToRaw(formData.memoranda.getCurrentContent())
      ) : '',
      rptax_machinery_co_owner_ids
    };

    if (tab === 3 && modalType === 'NEW') {
      createMachineryApplicationTransaction(args, (data) => {
        setModal({ isOpen: false });
        getMachineryApplicationsList();
        history.push(`/rpt/machinery/applications/${_.get(data, 'data.id')}`);
      });
    }

    return false;
  };

  useEffect(() => {
    getMachineryOwnerList();
  }, []);

  useEffect(() => {
    setFormData({
      ...c.MACHINERY_APPLICATION_FORM_DATA,
      property_region_id:
        _.get(
          CMS_COMPONENTS,
          'SMART_CITY_SET_SPECIFIC_REGION_FOR_ADDRESS_BILLING'
        ) || '',
      property_province_id:
        _.get(
          CMS_COMPONENTS,
          'SMART_CITY_SET_SPECIFIC_PROVINCE_FOR_ADDRESS_BILLING'
        ) || '',
      machine_location: 'LAND',
    });
  }, []);

  useEffect(() => {
    if (formData?.machine_location === 'BUILDING') {
      tab2Validator.onSetObjectRules({
        ...RULES.tab2.rules,
        rptax_building_owner_id: 'required',
      });
    }
    tab2Validator.onSetObjectRules(RULES.tab2.rules);
  }, [formData?.machine_location]);

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="m-1 p-1">
          {tab === 0 && (
            <OwnerDetails
              formData={formData}
              setFormData={setFormData}
              validateForm={tab0Validator}
            />
          )}
          {tab === 1 && (
            <AdministratorDetails
              formData={formData}
              setFormData={setFormData}
              setTab={setTab}
              validateForm={tab1Validator}
            />
          )}
          {tab === 2 && (
            <LandReference
              formData={formData}
              setFormData={setFormData}
              setTab={setTab}
              validateForm={tab2Validator}
            />
          )}
          {tab === 3 && (
            <GeneralDescription
              formData={formData}
              setFormData={setFormData}
              setTab={setTab}
              validateForm={tab3Validator}
              createRichTextEditor={createRichTextEditor}
            />
          )}
        </div>
      </form>
    </Modal.Body>
  );
}

NewDeclarationContainer.defaultProps = {
  modalType: '',
  transactionCode: '',
};

NewDeclarationContainer.propTypes = {
  getMachineryOwnerList: PropTypes.instanceOf(Function).isRequired,
  createMachineryApplicationTransaction:
    PropTypes.instanceOf(Function).isRequired,
  getMachineryApplicationsList: PropTypes.instanceOf(Function).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  transactionCode: PropTypes.string,
  createRichTextEditor: PropTypes.instanceOf(Function).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
  modalType: PropTypes.string,
  convertToRaw: PropTypes.instanceOf(Function).isRequired,
  draftToHtml: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = () => ({});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(NewDeclarationContainer);
